module.exports = __webpack_public_path__ + "assets/img/bg-a9cca043.png";